module.exports = __webpack_public_path__ + "static/img/zzc_7.40754da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_7.png
// module id = 2eIW
// module chunks = 19